import { render, staticRenderFns } from "./AddEditQuestionFillWords.vue?vue&type=template&id=1c1347e7"
import script from "./AddEditQuestionFillWords.vue?vue&type=script&lang=js"
export * from "./AddEditQuestionFillWords.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports